import { Component, OnInit } from '@angular/core';
import {FileUploader} from 'ng2-file-upload';

@Component({
  selector: 'app-importador',
  templateUrl: './importador.component.html',
  styleUrls: ['./importador.component.css']
})
export class ImportadorComponent implements OnInit {

  public uploader: FileUploader = new FileUploader({
    url: '../api/importador/importar',
    itemAlias: 'afip',
    headers: [
      { name: 'Access-Control-Allow-Origin', value: '*'}
    ]
  });

  oyo;
  oyocurado;
  
  constructor() { }

  ngOnInit(): void {
    // this.uplsoader.onAfterAddingFile = (file)=> { file.withCredentials = false; };
    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      console.log('Archivo de afip importado con éxito', item, status, response);
    };
    // tslint:disable-next-line: no-unused-expression
    this.uploader;
  }

  // tslint:disable-next-line: use-life-cycle-interface
  ngAfterViewInit() {
    console.log('uploader ready');
    this.uploader.onBeforeUploadItem = (item) => {
      item.withCredentials = false;
    };
    this.uploader.onAfterAddingFile = (item => {
      item.withCredentials = false;
    });
  }

  importar(){
    console.log('api', this.uploader);
  }


}
